import { Component } from 'react';

import styles from './ripple-loader.component.module.scss';

interface RippleLoaderComponentProps {
    size: number;
}

export class RippleLoaderComponent extends Component<RippleLoaderComponentProps> {

    constructor(props) {
        super(props);
    }

    render() {
        const size = this.props.size || 16;
        return <div className={styles['ripple-container']}
            style={{ width: `${size}px`, height: `${size}px`, fontSize: `${size}px`, }}>
            <div className={styles['ripple']}></div>
        </div>
    }
}
